module.exports = __webpack_public_path__ + "static/img/vancouver1.06305a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/vancouver1.jpg
// module id = 144
// module chunks = 9